import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import MeasurementDetailsForm from '../Forms/MeasurementDetailsForm';

const AddEditMeasurementDetailsModal = ({
	dataMeasurementDetail,
	isOpen,
	isEdit,
	handleToggleModal,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='md'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop='static'
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
			{isEdit ? 'Editar' : 'Realizar'} Medición
			</ModalHeader>
			<MeasurementDetailsForm
				dataMeasurementDetail={dataMeasurementDetail}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditMeasurementDetailsModal;
